import React, { useState } from "react";
import { SongList } from "./songList";
import { queueSong, searchHistory } from "../../api/song";
import { isSearcingHistory, historySongs } from "../../state/historySearch";

export function HistoryView() {
  const [search, setSearch] = useState<string>("");
  const [hasChangesSinceLastSearch, setHasChangesSinceLastSearch] =
      useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    historySongs.value = [];
    if (search && search !== "") {
      searchHistory(search);
      setHasChangesSinceLastSearch(false);
    }
  };

  const handleClearSearch = () => {
    historySongs.value = [];
    setSearch("");
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setHasChangesSinceLastSearch(true);
  };

  return (
      <div className="overflow-y-auto p-3 relative">
        <form onSubmit={handleSearch}>
          <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium sr-only text-white"
          >
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                  className="w-4 h-4 text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
              >
                <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
                value={search}
                onChange={handleChangeSearch}
                type="search"
                id="default-search"
                className="block w-full p-2 pl-10 pr-44 text-sm border rounded-lg bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-sky-500 focus:border-sky-500"
                placeholder="Search history"
                required
                autoComplete="off"
            />
            <button
                onClick={handleClearSearch}
                type="button"
                className="text-slate-400 hover:bg-gray-800/50 hover:text-white absolute right-[85px] bottom-[5px] focus:outline-none font-medium rounded-lg text-sm p-1"
            >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-5 h-5"
              >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <button
                type="submit"
                className="text-white absolute right-[5px] bottom-[5px] focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-1 bg-sky-700 hover:bg-sky-600 focus:ring-sky-900"
            >
              Search
            </button>
          </div>
        </form>
        <div className="relative md:min-h-[100px]">
          {isSearcingHistory.value && (
              <div
                  role="status"
                  className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2"
              >
                <svg
                    aria-hidden="true"
                    className="w-8 h-8 mr-2 animate-spin text-gray-600 fill-sky-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                  />
                  <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
          )}
          <SongList songs={historySongs.value} />
          {historySongs.value.length === 0 &&
              search !== "" &&
              !hasChangesSinceLastSearch &&
              !isSearcingHistory.value && (
                  <div className="text-sm text-slate-400 italic p-3">
                    No songs found in history
                  </div>
              )}
        </div>
      </div>
  );
}
